// FETCH ALL PRINTING_DC_INWARD DETAILS
export const FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST_DK = 'FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE_DK = 'FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PRINTING_DC_INWARD DETAILS
export const FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE PRINTING_DC_INWARD DETAILS
export const CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK = 'CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK';
export const CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK = 'CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK = 'CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK';

// UPDATE PRINTING_DC_INWARD DETAILS
export const UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK = 'UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK = 'UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF PRINTING_DC_INWARD DETAILS
export const FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK';

// DELETE PRINTING_DC_INWARD DETAILS
export const DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK = 'DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK';
export const DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK = 'DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK = 'DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM PRINTING_INWARD DETAILS
export const FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_FAILURE_DK';

export const RESET_PRINTING_DC_INWARD_DETAILS_INFO_DK = 'RESET_PRINTING_DC_INWARD_DETAILS_INFO_DK';

export const CREATE_PRINTING_DC_INWARD_DETAILS_FORM_DK = 'CREATE_PRINTING_DC_INWARD_DETAILS_FORM_DK';

export const UPDATE_PRINTING_DC_INWARD_DETAILS_FORM_DK = 'UPDATE_PRINTING_DC_INWARD_DETAILS_FORM_DK';

export const PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK = 'PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK';
